import {observer} from 'mobx-react';
import React from 'react';
import {PageHeading, PromiseMessage, PromiseRetry, Redirect} from '../../../lib/components';
import {ReactNodeGenerator} from '../../../lib/helpers';
import {UserEditForm} from '../edit-form/UserEditForm';
import {UserAddSceneStore} from './UserAddSceneStore';

function* renderer(store: UserAddSceneStore): ReactNodeGenerator {
  const lookupState = store.lookupState;
  const timeZonesState = store.timeZonesState;
  const saveState = store.saveState;

  if (store.redirectTo !== null) {
    yield (<Redirect to={store.redirectTo} key="redirect"/>);
    return;
  }

  yield (<PageHeading key="heading"> Add User </PageHeading>);

  yield (<PromiseMessage key="lookup-loader"
                         label="Loading levels"
                         state={lookupState}
                         align="center"/>);

  yield (<PromiseRetry key="lookup-retry"
                       state={lookupState}
                       retry={store.loadLookup}
                       align="center"/>);

  yield (<PromiseMessage key="timezone-loader"
                         label="Loading timezones"
                         state={timeZonesState}
                         align="center"/>);

  yield (<PromiseRetry key="timezone-retry"
                       state={timeZonesState}
                       retry={store.loadTimeZones}
                       align="center"/>);

  if (store.form === null)
    return;

  yield (
    <UserEditForm store={store.form!} key="user-edit-form"/>
  );

  const isSavePending = saveState?.isPending === true;

  yield (
    <div className="row" key="save-actions">
      <div className="col-auto ml-auto">
        <button type="button" className="btn btn-light"
                onClick={store.cancel}
                disabled={isSavePending}> Cancel
        </button>
        <button type="button" className="btn btn-primary"
                onClick={store.save}
                disabled={isSavePending}> Save
        </button>
      </div>
    </div>
  );

  yield (<PromiseMessage key="save-error"
                         label="Saving user"
                         state={saveState}
                         align="right"/>);
}

@observer
export class UserAddScene extends React.Component {
  store: UserAddSceneStore;

  constructor(props: any) {
    super(props);
    this.store = new UserAddSceneStore();
  }

  componentDidMount() {
    this.store.loadLookup();
    this.store.loadTimeZones();
  }

  render() {
    return Array.from(renderer(this.store));
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}

